import React, { useEffect, useState } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import DailyFloodReportStatusForm from "./DailyColdWaveReportStatusForm";
import moment from "moment";
import DailyColdWaveReportStatusForm from "./DailyColdWaveReportStatusForm";
import "../ReportEnhanced.css";
//import DMSHeader from "../../DMSHeader/DMSHeader";

const DailyColdWaveReportStatus = () => {
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  useEffect(() => {
    GridStack.init();
  }, []);
  const coldWaveReportStatusfile = `DailyColdWaveReportStatus_${selectedDate}`;
  console.log("filename in reprotstatus=====", coldWaveReportStatusfile);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title="Cold Wave Daily Report Status"
          fileName={`DailyColdWaveReportStatus`}
          increaseHeaderHeight={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 10,
      id: 2,
      component: (
        <DailyColdWaveReportStatusForm
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      ),
    },
  ];

  return (
    <div className="report-enhanced-wrapper">
      <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
        <GridItem layoutData={layoutData} />
      </div>
    </div>
  );
};

export default DailyColdWaveReportStatus;

